import { Component } from '@angular/core';

@Component({
  selector: 'crtz-avaliacao-review-loader',
  templateUrl: './avaliacao-review-loader.component.html',
  styleUrls: ['./avaliacao-review-loader.component.scss']
})
export class AvaliacaoReviewLoaderComponent { }
